import { createAsyncThunk } from "@reduxjs/toolkit";
import { showToast } from "../toast/reducer";
import {
  getHouseRules,
  updateHouseRules,
  getPrivacyPolicy,
  updatePrivacyPolicy,
  getTermsAndConditions,
  updateTermsAndConditions,
  getCancellationPolicy,
  updateCancellationPolicy,
} from "../../helpers/apis";

// House Rules Thunks
export const fetchHouseRules = createAsyncThunk(
  "staticPages/fetchHouseRules",
  async (_, thunkAPI) => {
    try {
      const response = await getHouseRules();
      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch house rules";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const updateHouseRulesThunk = createAsyncThunk(
  "staticPages/updateHouseRules",
  async (data, thunkAPI) => {
    try {
      const response = await updateHouseRules(data);
      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to update house rules";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// Privacy Policy Thunks
export const fetchPrivacyPolicy = createAsyncThunk(
  "staticPages/fetchPrivacyPolicy",
  async (_, thunkAPI) => {
    try {
      const response = await getPrivacyPolicy();
      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch privacy policy";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const updatePrivacyPolicyThunk = createAsyncThunk(
  "staticPages/updatePrivacyPolicy",
  async (data, thunkAPI) => {
    try {
      const response = await updatePrivacyPolicy(data);
      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to update privacy policy";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// Terms and Conditions Thunks
export const fetchTermsAndConditions = createAsyncThunk(
  "staticPages/fetchTermsAndConditions",
  async (_, thunkAPI) => {
    try {
      const response = await getTermsAndConditions();
      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch terms and conditions";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const updateTermsAndConditionsThunk = createAsyncThunk(
  "staticPages/updateTermsAndConditions",
  async (data, thunkAPI) => {
    try {
      const response = await updateTermsAndConditions(data);
      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to update terms and conditions";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// Cancellation Policy Thunks
export const fetchCancellationPolicy = createAsyncThunk(
  "staticPages/fetchCancellationPolicy",
  async (_, thunkAPI) => {
    try {
      const response = await getCancellationPolicy();
      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch cancellation policy";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const updateCancellationPolicyThunk = createAsyncThunk(
  "staticPages/updateCancellationPolicy",
  async (data, thunkAPI) => {
    try {
      const response = await updateCancellationPolicy(data);
      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to update cancellation policy";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
